export default __webpack_public_path__ + "static/media/counter_orange.06f4412d.svg";